export const DeleteCustomRoleApi = Symbol.for('DeleteCustomRoleApi');
